import { call, put, takeEvery } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './VolumeTrendActionType';
import * as actions from './VolumeTrendActions';
import * as services from './VolumeTrendServices';
import SweetAlert from '../../../components/sweetalert/SweetAlert';


// Volume Trend Report Saga
function* fetchVolumeTrendReportSaga(action) {
    try {
        const response = yield call(services.fetchVolumeTrendReport, action.payload);
        yield put(actions.volumeTrendReportSuccess(response?.values));
    } catch (error) {
        console.error("fetchVolumeTrendReportSaga Error:", error);
        yield put(actions.volumeTrendReportFailure(error.message || 'Failed to fetch volume trend report'));
        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'Failed to fetch volume trend report',
            showConfirmButton: true
        });
    }
}

//Pivot Volume Trend By ID Saga
function* fetchPivotVolumeTrendByIdSaga(action) {
    try {
        const response = yield call(services.fetchPivotVolumeTrendByIdEncore, action.payload);
        yield put(actions.pivotVolumeTrendByIdSuccess(response?.values));
    } catch (error) {
        console.error("fetchPivotVolumeTrendByIdSaga Error:", error);
        yield put(actions.pivotVolumeTrendByIdFailure(error.message || 'Failed to fetch pivot volume trend by ID'));
        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'Failed to fetch pivot volume trend by ID',
            showConfirmButton: true
        });
    }
}

//Unread Pivot Volume Trend By ID Saga
function* fetchUnreadPivotVolumeTrendByIdSaga(action) {
    try {
        const response = yield call(services.fetchUnreadPivotVolumeTrendById, action.payload);
        yield put(actions.unreadPivotVolumeTrendByIdSuccess(response?.values));
    } catch (error) {
        console.error("fetchUnreadPivotVolumeTrendByIdSaga Error:", error);
        yield put(actions.unreadPivotVolumeTrendByIdFailure(error.message || 'Failed to fetch unread pivot volume trend by ID'));
        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'Failed to fetch unread pivot volume trend by ID',
            showConfirmButton: true
        });
    }
}

//Unread Pivot Volume Trend By ID Site Saga

function* fetchUnreadPivotVolumeTrendByIdSiteSaga(action) {
    try {
        const response = yield call(services.fetchUnreadPivotVolumeTrendByIdSite, action.payload);
        yield put(actions.unreadPivotVolumeTrendByIdSiteSuccess(response?.values));
    } catch (error) {
        console.error("fetchUnreadPivotVolumeTrendByIdSiteSaga Error:", error);
        yield put(actions.unreadPivotVolumeTrendByIdSiteFailure(error.message || 'Failed to fetch unread pivot volume trend by ID site'));
        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'Failed to fetch unread pivot volume trend by ID site',
            showConfirmButton: true
        });
    }
}

function* fetchUnreadPivotVolumeTrendByIdSitePrioritySaga(action) {
    try {
        const response = yield call(services.fetchUnreadPivotVolumeTrendByIdSitePriority, action.payload);
        yield put(actions.unreadPivotVolumeTrendByIdSitePrioritySuccess(response?.values));
    } catch (error) {
        console.error("fetchUnreadPivotVolumeTrendByIdSitePrioritySaga Error:", error);
        yield put(actions.unreadPivotVolumeTrendByIdSitePriorityFailure(error.message || 'Failed to fetch unread pivot volume trend by site priority'));
        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'Failed to fetch unread pivot volume trend by site priority',
            showConfirmButton: true
        });
    }
}

// RollOver ExamData Volume Trend Saga
function* fetchRolloverExamDataVolumeTrendSaga(action) {
    try {
        const response = yield call(services.fetchRolloverExamDataVolumeTrendEncore, action.payload);
        yield put(actions.rollOverExamDataVolumeTrendSuccess(response?.values));

        // Trigger dropdown refresh right after rollover success.
        if (action?.payload?.FromDate && action?.payload?.ToDate) {
            yield put(actions.getVolumeTrendDropDownsRequest({
                FromDate: action.payload.FromDate,
                ToDate: action.payload.ToDate,
                CreatedBy: action?.payload?.CreatedBy || 0
            }));
        }
    } catch (error) {
        console.error("fetchRolloverExamDataVolumeTrendSaga Error:", error);
        yield put(actions.rollOverExamDataVolumeTrendFailure(error.message || 'Failed to fetch rollover exam data volume trend'));
        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'Failed to fetch rollover exam data volume trend',
            showConfirmButton: true
        });
    }
}

// Delete Scheduling ForeCast Report Saga
function* deleteSchedulingForecastReportSaga(action) {
    try {
        const response = yield call(
            services.deleteSchedulingForecastReport,
            action.payload
        );

        yield put(
            actions.deleteSchedulingForecastReportSuccess(response?.values)
        );

        SweetAlert.success({
            title: 'Success',
            text: 'Successfully Deleted Volume Trend Report',
            icon: 'success',
            confirmButtonText: 'OK',
            confirmButtonColor: '#6366f1',
            timer: 3000,
            timerProgressBar: true
        });

        // RE-FETCH LIST AFTER DELETE
        yield put(actions.volumeTrendReportRequest({
            SkipNoOfRecords: 0,
            PageSize: 100,
            sSearch: null,
            sortColumn: 'VolumeTrendReportID',
            sortColumnDir: 'desc'
        }));

    } catch (error) {
        console.error("deleteSchedulingForecastReportSaga Error:", error);
        yield put(
            actions.deleteSchedulingForecastReportFailure(
                error.message || 'Failed to delete scheduling forecast report'
            )
        );
        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'Failed to delete scheduling forecast report',
            showConfirmButton: true
        });
    }
}

// Get Volume Trend ReportsBy ID Saga
function* fetchVolumeTrendReportsByIdSaga(action) {
    try {
        const response = yield call(services.fetchVolumeTrendReportsById, action.payload);
        yield put(actions.getVolumeTrendReportsByIdSuccess(response?.values));
    } catch (error) {
        console.error("fetchVolumeTrendReportsByIdSaga Error:", error);
        yield put(actions.getVolumeTrendReportsByIdFailure(error.message || 'Failed to fetch volume trend reports by ID'));
        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'Failed to fetch volume trend reports by ID',
            showConfirmButton: true
        });
    }
}

function* fetchVolumeTrendSchedulingForecastByIdSaga(action) {
    try {
        const toBoolean = (value) =>
            value === true || value === 'true' || value === 1 || value === '1';

        const isPriorityGroupLevel = toBoolean(action.payload?.IsPriorityGroupLevel);
        const isFacilityLevel = toBoolean(action.payload?.IsFacilityLevel);

        const response = isPriorityGroupLevel
            ? yield call(services.fetchVolumeTrendSchedulingForecastSitePriorityById, action.payload)
            : isFacilityLevel
                ? yield call(services.fetchVolumeTrendSchedulingForecastSiteById, action.payload)
                : yield call(services.fetchVolumeTrendSchedulingForecastById, action.payload);

        yield put(actions.getVolumeTrendSchedulingForecastByIdSuccess(response?.values));
    } catch (error) {
        console.error("fetchVolumeTrendSchedulingForecastByIdSaga Error:", error);
        yield put(actions.getVolumeTrendSchedulingForecastByIdFailure(error.message || 'Failed to fetch scheduling forecast by ID'));
        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'Failed to fetch scheduling forecast by ID',
            showConfirmButton: true
        });
    }
}

function* fetchVolumeTrendDropDownsSaga(action) {
    try {
        const response = yield call(services.fetchVolumeTrendDropDowns, action.payload);
        yield put(actions.getVolumeTrendDropDownsSuccess(response?.values));
    } catch (error) {
        console.error('fetchVolumeTrendDropDownsSaga Error:', error);
        yield put(actions.getVolumeTrendDropDownsFailure(error.message || 'Failed to fetch volume trend dropdowns'));
        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'Failed to fetch volume trend dropdowns',
            showConfirmButton: true
        });
    }
}

// Save Volume Trend Report Saga
function* saveVolumeTrendReportSaga(action) {
    try {
        const response = yield call(services.saveVolumeTrendReportEncore, action.payload);
        yield put(actions.saveVolumeTrendReportSuccess(response?.values));
        SweetAlert.success({
            title: 'Success',
            text: 'Successfully Saved Exam Data Volume Trend Report',
            icon: 'success',
            confirmButtonText: 'OK',
            confirmButtonColor: '#6366f1',
            timer: 3000,
            timerProgressBar: true
        });
    } catch (error) {
        console.error("saveVolumeTrendReportSaga Error:", error);
        yield put(actions.saveVolumeTrendReportFailure(error.message || 'Failed to save volume trend report'));
        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'Failed to save volume trend report',
            showConfirmButton: true
        });
    }
}

// Draft Save Volume Trend Report Saga
// function* draftSaveVolumeTrendReportSaga(action) {
//     try {
//         const response = yield call(services.draftSaveVolumeTrendReport, action.payload);
//         yield put(actions.draftSaveVolumeTrendReportSuccess(response?.values));
//         SweetAlert.success({
//             title: 'Success',
//             text: 'Successfully saved Volume Trend Report as Draft',
//             icon: 'success',
//             confirmButtonText: 'OK',
//             confirmButtonColor: '#6366f1',
//             timer: 3000,
//             timerProgressBar: true
//         });

//         // RE-FETCH LIST AFTER DELETE
//         yield put(actions.volumeTrendReportRequest({
//             SkipNoOfRecords: 0,
//             PageSize: 100,
//             sSearch: null,
//             sortColumn: 'VolumeTrendReportID',
//             sortColumnDir: 'desc'
//         }));
//     } catch (error) {
//         console.error("draftSaveVolumeTrendReportSaga Error:", error);
//         yield put(actions.draftSaveVolumeTrendReportFailure(error.message || 'Failed to draft save volume trend report'));
//         SweetAlert.error({
//             title: 'Error!',
//             text: error.message || 'Failed to draft save volume trend report',
//             showConfirmButton: true
//         });
//     }
// }
function* draftSaveVolumeTrendReportSaga(action) {
    try {
        const response = yield call(services.draftSaveVolumeTrendReport, action.payload);

        if (response?.success) {
            yield put(actions.draftSaveVolumeTrendReportSuccess(response?.values));
            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage
            });

            yield put(actions.volumeTrendReportRequest({
                SkipNoOfRecords: 0,
                PageSize: 100,
                sSearch: null,
                sortColumn: 'VolumeTrendReportID',
                sortColumnDir: 'desc'
            }));

        } else {
            yield put(actions.draftSaveVolumeTrendReportFailure(response?.errorMessage));
            SweetAlert.error({
                title: 'Error!',
                text: response?.errorMessage
            });
        }

    } catch (error) {
        console.error("draftSaveVolumeTrendReportSaga Error:", error);
        yield put(actions.draftSaveVolumeTrendReportFailure(error?.message || 'Failed to draft save volume trend report'));
        SweetAlert.error({
            title: 'Error!',
            text: 'Failed to draft save volume trend report.'
        });
    }
}

// Publish Volume Trend Report Saga
function* publishVolumeTrendReportSaga(action) {
    try {
        const response = yield call(services.publishVolumeTrendReport, action.payload);
        yield put(actions.publishVolumeTrendReportSuccess(response?.values));
        SweetAlert.success({
            title: 'Success',
            text: 'Successfully published Volume Trend Report',
            icon: 'success',
            confirmButtonText: 'OK',
            confirmButtonColor: '#6366f1',
            timer: 3000,
            timerProgressBar: true
        });
        // RE-FETCH LIST AFTER DELETE
        yield put(actions.volumeTrendReportRequest({
            SkipNoOfRecords: 0,
            PageSize: 100,
            sSearch: null,
            sortColumn: 'VolumeTrendReportID',
            sortColumnDir: 'desc'
        }));
    } catch (error) {
        console.error("publishVolumeTrendReportSaga Error:", error);
        yield put(actions.publishVolumeTrendReportFailure(error.message || 'Failed to publish volume trend report'));
        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'Failed to publish volume trend report',
            showConfirmButton: true
        });
    }
}

// Export Volume Trend Report Saga
function* exportVolumeTrendReportSaga(action) {
    try {
        const response = yield call(services.exportVolumeTrendReport, action.payload);
        yield put(actions.exportVolumeTrendReportSuccess(response?.values));
        SweetAlert.success({
            title: 'Success',
            text: 'Successfully exported Volume Trend Report',
            icon: 'success',
            confirmButtonText: 'OK',
            confirmButtonColor: '#6366f1',
            timer: 3000,
            timerProgressBar: true
        });
    } catch (error) {
        console.error("exportVolumeTrendReportSaga Error:", error);
        yield put(actions.exportVolumeTrendReportFailure(error.message || 'Failed to export volume trend report'));
        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'Failed to export volume trend report',
            showConfirmButton: true
        });
    }
}

// Report Note Saga
function* fetchReportNoteSaga(action) {
    try {
        const response = yield call(services.fetchReportNote, action.payload);
        yield put(actions.reportNoteSuccess(response?.values));
    } catch (error) {
        console.error("fetchReportNoteSaga Error:", error);
        yield put(actions.reportNoteFailure(error.message || 'Failed to fetch report note'));
        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'Failed to fetch report note',
            showConfirmButton: true
        });
    }
}

// Report Save Note Saga
function* saveReportNoteSaga(action) {
    try {
        const response = yield call(services.saveReportNote, action.payload);
        yield put(actions.saveReportNoteSuccess(response?.values));
        SweetAlert.success({
            title: 'Success!',
            text: response?.resultMessage || 'Status updated successfully.'
        });
        // RE-FETCH LIST AFTER DELETE
        yield put(actions.volumeTrendReportRequest({
            SkipNoOfRecords: 0,
            PageSize: 100,
            sSearch: null,
            sortColumn: 'VolumeTrendReportID',
            sortColumnDir: 'desc'
        }));
    } catch (error) {
        console.error("saveReportNoteSaga Error:", error);
        yield put(actions.saveReportNoteFailure(error.message || 'Failed to save report note'));
        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'Failed to save report note',
            showConfirmButton: true
        });
    }
}

// Get Exam Data Volume Trend Saga (for Roll Over Demand)
function* fetchExamDataVolumeTrendSaga(action) {
    try {
        const response = yield call(services.fetchExamDataVolumeTrend, action.payload);
        yield put(actions.getExamDataVolumeTrendSuccess(response?.values));

        // After success, refresh the related data based on payload
        const { VolumeTrendReportID } = action.payload;

        if (VolumeTrendReportID) {
            // Refresh pivot data
            yield put(actions.pivotVolumeTrendByIdRequest({
                SkipNoOfRecords: 0,
                PageSize: 100,
                sSearch: null,
                ReportID: VolumeTrendReportID
            }));

            // Refresh unread pivot data
            yield put(actions.unreadPivotVolumeTrendByIdRequest({
                SkipNoOfRecords: 0,
                PageSize: 100,
                sSearch: null,
                ReportID: VolumeTrendReportID
            }));

            // Refresh unread pivot site data
            yield put(actions.unreadPivotVolumeTrendByIdSiteRequest({
                SkipNoOfRecords: 0,
                PageSize: 100,
                sSearch: null,
                ReportID: VolumeTrendReportID
            }));

            // Refresh GetVolumeTrendReportsByID
            yield put(actions.getVolumeTrendReportsByIdRequest({
                ReportID: VolumeTrendReportID,
                TabNumber: null,
                IsForeCastOnly: true
            }));
        }
    } catch (error) {
        console.error("fetchExamDataVolumeTrendSaga Error:", error);
        yield put(actions.getExamDataVolumeTrendFailure(error.message || 'Failed to fetch exam data volume trend'));
        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'Failed to fetch exam data volume trend',
            showConfirmButton: true
        });
    }
}


// Watcher saga: spawns new saga tasks on each request
function* VolumeTrendSaga() {
    yield takeEvery(types.VOLUME_TREND_REQUEST, fetchVolumeTrendReportSaga);
    yield takeEvery(types.PIVOT_VOLUME_TREND_BY_ID_REQUEST, fetchPivotVolumeTrendByIdSaga);
    yield takeEvery(types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_REQUEST, fetchUnreadPivotVolumeTrendByIdSaga);
    yield takeEvery(types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_REQUEST, fetchUnreadPivotVolumeTrendByIdSiteSaga);
    yield takeEvery(types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_PRIORITY_REQUEST, fetchUnreadPivotVolumeTrendByIdSitePrioritySaga);
    yield takeEvery(types.ROLLOVER_EXAMDATA_VOLUME_TREND_REQUEST, fetchRolloverExamDataVolumeTrendSaga);
    yield takeEvery(types.DELETE_SCHEDULING_FORECAST_REPORT_REQUEST, deleteSchedulingForecastReportSaga);
    yield takeEvery(types.GET_VOLUME_TREND_REPORTS_BY_ID_REQUEST, fetchVolumeTrendReportsByIdSaga);
    yield takeEvery(types.GET_VOLUME_TREND_SCHEDULING_FORECAST_BY_ID_REQUEST, fetchVolumeTrendSchedulingForecastByIdSaga);
    yield takeEvery(types.SAVE_VOLUME_TREND_REPORT_REQUEST, saveVolumeTrendReportSaga);
    yield takeEvery(types.DRAFT_SAVE_VOLUME_TREND_REPORT_REQUEST, draftSaveVolumeTrendReportSaga);
    yield takeEvery(types.PUBLISH_VOLUME_TREND_REPORT_REQUEST, publishVolumeTrendReportSaga);
    yield takeEvery(types.EXPORT_VOLUME_TREND_REPORT_REQUEST, exportVolumeTrendReportSaga);
    yield takeEvery(types.REPORT_NOTE_REQUEST, fetchReportNoteSaga);
    yield takeEvery(types.SAVE_REPORT_NOTE_REQUEST, saveReportNoteSaga);
    yield takeEvery(types.GET_EXAM_DATA_VOLUME_TREND_REQUEST, fetchExamDataVolumeTrendSaga);
    yield takeEvery(types.GET_VOLUME_TREND_DROPDOWNS_REQUEST, fetchVolumeTrendDropDownsSaga);
}

export default VolumeTrendSaga;

